const loadScrollDown = () => {
    const downButton = document.querySelector('.page-intro .down')

    if (downButton) {
        downButton.addEventListener('click', () => {
            const timer = setInterval(() => {
                window.scrollBy(0, 15)

                if (document.querySelector('.page-intro').getBoundingClientRect().bottom <= 70) {
                    clearInterval(timer)
                }
            }, 5)
        })
    }
}

export default loadScrollDown



// WEBPACK FOOTER //
// ./js/scrollDown.js